export const newTabLinkProps = { target: '_blank', rel: 'noopener noreferrer' }
